import { createContext, useContext, useEffect, useState } from 'react';
import { API_BASE_URL } from '../lib/api';

const PublicAuthContext = createContext({ user: null, loading: true });

async function restoreCustomerSession() {
  const controller = new AbortController();
  const timeoutId = window.setTimeout(() => controller.abort(), 4000);
  try {
    const response = await fetch(`${API_BASE_URL}/auth/refresh`, {
      method: 'POST',
      credentials: 'include',
      headers: { Accept: 'application/json', 'X-Bridge-Client': 'customer' },
      signal: controller.signal
    });
    if (!response.ok) return null;
    const payload = await response.json();
    return payload.user?.userType === 'CUSTOMER' ? payload.user : null;
  } catch {
    return null;
  } finally {
    window.clearTimeout(timeoutId);
  }
}

export function PublicAuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    restoreCustomerSession().then((sessionUser) => {
      if (active) {
        setUser(sessionUser);
        setLoading(false);
      }
    });
    return () => { active = false; };
  }, []);

  return <PublicAuthContext.Provider value={{ user, loading }}>{children}</PublicAuthContext.Provider>;
}

export function usePublicAuth() {
  return useContext(PublicAuthContext);
}
